import { createFileRoute } from "@tanstack/react-router";
import { pageHead } from "../utils/page-title";

export const Route = createFileRoute("/learn")({
  head: () => pageHead("Learn Human Design", { canonicalPath: "/learn" }),
});
